import React from 'react'
import TextField from '@material-ui/core/TextField'
import ExpandablePanel from '../../components/controls/ExpandablePanel'
import { controlHasError } from '../../lib/errorHandler'
import MainStyle from '../../styles/MainStyle'
import { connect } from 'react-redux'
import * as actions from '../../store/actions'
import ZasadyRachunkowosciStyle from '../../styles/ZasadyRachunkowosciStyle'
import InfoPanel from '../../components/InfoPanel'
import PrintText from '../../lib/PrintText'

function ZmianyPolitykiRachunkowosci(props) {
  const rolledContent = (
    <div>
      W tym miejscu należy opisać dokonane ze skutkiem od pierwszego dnia roku
      obrotowego zmiany zasad (polityki) rachunkowości, w szczególności zasad
      grupowania operacji gospodarczych, metod wyceny aktywów i pasywów,
      dokonywania odpisów amortyzacyjnych, ustalania wyniku finansowego i
      sporządzania jednostkowych sprawozdań finansowych oraz skonsolidowanego
      sprawozdania finansowego wraz z podaniem ich przyczyny.
      <br />
      Podanie tych informacji jest obowiązkowe.
    </div>
  )
  return (
    <MainStyle>
      <InfoPanel canExpand={false} rolledContent={rolledContent} />
      <ZasadyRachunkowosciStyle>
        <ExpandablePanel title="ZMIANY ZASAD (POLITYKI) RACHUNKOWOŚCI">
          <div className="subsection">
            {props.czyPodsumowanie ? (
              <PrintText
                text={props.section.Dane.Opis}
              />
            ) : (
              <TextField
                error={controlHasError(
                  props.validityErrors,
                  'Opis',
                  props.section.Dane.Opis,
                  true,
                )}
                name="Opis"
                label="Opis"
                multiline
                variant="outlined"
                title={props.section.Dane.Opis}
                defaultValue={props.section.Dane.Opis}
                onBlur={(e) =>
                  props.onSetSectionData('Opis', e.target.value, 0)
                }
              />
            )}
          </div>
        </ExpandablePanel>
      </ZasadyRachunkowosciStyle>
    </MainStyle>
  )
}

const mapStateToProps = (state) => {
  return {
    validityErrors: state.sprawozdanie.validityErrors
      ? state.sprawozdanie.validityErrors
      : [],
    czyPodsumowanie: state.sprawozdanie.czyPodsumowanie,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSetSectionData: (name, value, index) => {
      dispatch(actions.setSectionData(name, value, index))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ZmianyPolitykiRachunkowosci)
